import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import Hero from '@/components/landing/hero'
import TechMarquee from '@/components/landing/tech-marquee'
import GamesSection from '@/components/landing/games-section'
import ThemingSection from '@/components/landing/theming-section'
import ServerSection from '@/components/landing/server-section'
import FairnessSection from '@/components/landing/fairness-section'
import IntegrationSection from '@/components/landing/integration-section'
import PricingSection from '@/components/landing/pricing-section'
import FaqSection from '@/components/landing/faq-section'
import FinalCta from '@/components/landing/final-cta'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />
            <Hero />
            <TechMarquee />
            <GamesSection />
            <ThemingSection />
            <ServerSection />
            <FairnessSection />
            <IntegrationSection />
            <PricingSection />
            <FaqSection />
            <FinalCta />
        </Layout>
    )
}

export default Home
